module.exports = __webpack_public_path__ + "img/player-back-icon.8e9f1937.svg";